import PropTypes from 'prop-types';
import { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import CloseIcon from 'dibs-icons/exports/Close';
import { localStorage, sessionStorage } from 'dibs-browser-storage';
import get from 'lodash.get';
import classnames from 'classnames';

import { GDPR_KEY_AGREED, GDPR_KEY_NOT_APPLICABLE } from './constants';
import styles from './CookieNotification-style.scss';

class CookieNotification extends Component {
    constructor() {
        super();
        this.onClose = this.onClose.bind(this);
        this.state = {
            isVisible: false,
            isCriteoVisible: false,
        };
    }

    componentDidMount() {
        const isGdprApplicable =
            get(this.props, 'viewer.gdprDisplayInfo.isGdprApplicable') || false;
        const isLocalSet = !!localStorage.getItem(GDPR_KEY_AGREED);
        const isSessionSet = !!sessionStorage.getItem(GDPR_KEY_NOT_APPLICABLE);

        if (isGdprApplicable && !isLocalSet && !isSessionSet) {
            this.setCriteoBannerIsVisible();
            /* eslint-disable react/no-did-mount-set-state */
            this.setState({
                isVisible: true,
            });
            /* eslint-enable react/no-did-mount-set-state */
        } else {
            // if GDPR is not applicable this session variable prevents form unnecessary CookieNotification render
            sessionStorage.setItem(GDPR_KEY_NOT_APPLICABLE, true);
        }
    }

    setCriteoBannerIsVisible() {
        const isCriteoVisible = !!document.getElementById('cto_cookies_header_message');

        if (isCriteoVisible) {
            this.setState({ isCriteoVisible });
        } else {
            const self = this;

            Object.defineProperties(window, {
                CriteoRedexApplied: {
                    set(value) {
                        if (document.getElementById('cto_cookies_header_message')) {
                            self.setState({ isCriteoVisible: !!value });
                        }
                    },
                },
            });
        }
    }

    onClose() {
        localStorage.setItem(GDPR_KEY_AGREED, true);
        this.setState({
            isVisible: false,
        });
    }

    render() {
        if (!this.state.isVisible) {
            return null;
        }

        const message = get(this, 'props.viewer.gdprDisplayInfo.cookieNotificationMessage');
        const { isCriteoVisible } = this.state;
        const stickyBarClassName = classnames(styles.stickyBar, {
            [styles.criteoVisible]: isCriteoVisible,
        });

        return (
            <div className={stickyBarClassName} data-tn="cookie-notification-wrapper">
                <div
                    dangerouslySetInnerHTML={{ __html: message }}
                    data-tn="cookie-notification-message"
                />
                <div
                    className={styles.closeButton}
                    onClick={this.onClose}
                    data-tn="cookie-notification-close"
                >
                    <CloseIcon />
                </div>
            </div>
        );
    }
}

CookieNotification.propTypes = {
    viewer: PropTypes.object,
};

export default createFragmentContainer(CookieNotification, {
    viewer: graphql`
        fragment CookieNotification_viewer on Viewer {
            gdprDisplayInfo {
                isGdprApplicable(countryCode: $userCountryCode)
                cookieNotificationMessage
            }
        }
    `,
});
